import { render } from "./PanelAvisosGenerarRecibo.vue?vue&type=template&id=233cf1e1"
import script from "./PanelAvisosGenerarRecibo.vue?vue&type=script&lang=js"
export * from "./PanelAvisosGenerarRecibo.vue?vue&type=script&lang=js"
script.render = render

export default script